
import React from 'react';
import { Button } from "@/components/ui/button";
import { RefreshCw } from "lucide-react";

interface MarketDataActionButtonsProps {
  onRefresh: () => void;
  isLoading: boolean;
}

export const MarketDataActionButtons = ({ onRefresh, isLoading }: MarketDataActionButtonsProps) => {
  return (
    <div className="flex gap-2 flex-wrap px-1">
      <Button
        onClick={onRefresh}
        variant="outline"
        disabled={isLoading}
        className="text-sm sm:text-base"
      >
        <RefreshCw className="h-3 w-3 sm:h-4 sm:w-4 mr-2" />
        Refresh
      </Button>
    </div>
  );
};
